import { Flex } from "@mantine/core";
import { Spinner } from "@onengine/component-library";

import type { SpinnerSize } from "@onengine/component-library";

interface IAppLoaderProps {
  size?: SpinnerSize;
  h?: string | number;
  withContainer?: boolean;
}

const Loader = ({ h = "70vh", withContainer = true, size }: IAppLoaderProps) => {
  if (!withContainer) {
    return <Spinner size={size} />;
  }

  return (
    <Flex direction="column" align="center" justify="center" h={h} w={"100%"}>
      <Spinner size={size} />
    </Flex>
  );
};

export default Loader;
